<template lang="pug">
	.web-services--output-ai-generator
		DxButton(:text="$tCaption('AI Generator')", :type="output.AiGeneratorConfig ? 'default' : 'normal'" @click="show")
		Popup(v-if="popupVisible", :popupVisible.sync="popupVisible", :title="title", :height="aiGenerator.Id ? 420 : 220", :width="340")
			.content
				.flex-col.space-large
					Dropdown(:getTotal="(r) => r.TotalNumberOfRecords", :getItems="(r) => r.Results", :getData="getAiGenerators",
						:columns="[{ dataField: 'Name', caption: $tCaption('Name') }]",
						displayExpr="Name",
						valueExpr="Oid",
						:placeholder="$tCaption('AI Prompt')",
						:selectedItems="aiGenerator.Id",
						:showColumnHeaders="false",
						:filtersVisible="false",
						:searchVisible="true",
						:multiple="false",
						@change="v => aiGenerator.Id = v")
					.flex-col.space-medium(v-if="parametersValues.length")
						.font-big.upper.grey {{$tCaption('Parameters')}}
						.flex-col(v-for="param in parametersValues")
							span {{param.Name}}
							.font-tiny.grey(v-if="param.Description") {{param.Description}}
							Dropdown(:getTotal="(r) => r.length", :getItems="(r) => r", :getData="getParametersAvailableValues",
								:columns="[{ dataField: 'name', caption: $tCaption('Name') }]",
								displayExpr="name",
								valueExpr="key",
								:placeholder="$tCaption('Linked input/ouput')",
								:selectedItems="param.Value",
								:showColumnHeaders="false",
								:filtersVisible="false",
								:searchVisible="true",
								:multiple="false",
								:pageSize="999",
								stylingMode="filled",
								@change="v => setParamValue(param, v)")
				Loader(v-if="isLoading", :fullscreen="true", text="")
			template(slot="actions-left")
				DxButton(:text="$tCaption('Clear', '@actions')", @click="clear", v-if="aiGenerator.Id")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Cancel', '@actions')", @click="popupVisible = false")
				DxButton(:text="$tCaption('Save', '@actions')", type="default", @click="save()")
</template>

<script>
import _ from 'lodash';
import DxButton from 'devextreme-vue/button';
import Popup from 'app-core/Popup.vue';
import Dropdown from 'app-core/Dropdown.vue';
import Loader from 'app-core/Loader.vue';

export default {
	translationCategory: 'webServiceCaller.OutputAiGenerator',
	components: { DxButton, Popup, Dropdown, Loader },
	props: ['output', 'service'],
	data() {
		return {
			popupVisible: false,
			aiGenerator: {
				Id: null,
				Parameters: []
			},
			isLoading: 0,
			parameters: []
		};
	},
	computed: {
		title() {
			return this.$tCaption('AI Generator: <OUTPUTNAME>').replace(/<OUTPUTNAME>/g, this.output?.Name);
		},
		parametersValues() {
			return this.parameters.map(f => {
				const genParam = this.aiGenerator.Parameters.find(p => p.ParameterId === f.Oid);
				return {
					...f,
					Value: genParam?.Output ? `output_${genParam.Output}` : (genParam.Input ? `input_${genParam.Input}` : null),
					GenParam: genParam
				}
			})
		},
		availableParams() {
			return [
				...((this.service.JsonDefinition.Parameters || []).map(f => ({
					type: 'input',
					name: f.Name,
					param: f,
					key: `input_${f.Name}`
				}))),
				...((this.service.JsonDefinition.Outputs || []).filter(f => f.Status != 2).map(f => ({
					type: 'ouput',
					name: f.Name,
					param: f,
					key: `output_${f.Name}`
				}))),
			];
		},
	},
	watch: {
		'aiGenerator.Id'() {
			this.loadParameters();
		}
	},
	mounted() {
		
	},
	methods: {
		setParamValue(param, v) {
			if (__DEBUG__)
				console.debug('Set param value', { v });
			const isOutput = `${v}`.startsWith('output_');
			v = `${v}`.replace(/output\_/, '').replace(/input\_/, '');
			param.GenParam[isOutput ? 'Output' : 'Input'] = v;
			param.GenParam[!isOutput ? 'Output' : 'Input'] = null;
		},
		async getParametersAvailableValues(page, size, opts) {
			if (opts?.byKey) {
				return this.availableParams.filter(f => f.key === opts?.byKey);
			}
			return this.availableParams;
		},
		getAiGenerators(pageIndex, limit, opts) {
			if (opts?.byKey) {
				return this.$Data.getExternalApi('AIScriptGenerator/Get', `id=${opts.byKey}`).then(r => ({ Results: [r] }));
			}
			return this.$Data.getExternalApi('AIScriptGenerator/List', `filterCriteria=[["UseType", "=", "WebService"], "AND", ["WebServiceCategory.Oid", "=", "${this.service?.ServiceCategory?.Oid}"]]&page=${pageIndex + 1}`, limit);
		},
		show() {
			if (__DEBUG__)
				window.outputAiGenerator = this;
			if (this.output?.AiGeneratorConfig) {
				this.aiGenerator = this.output?.AiGeneratorConfig ? _.cloneDeep(this.output?.AiGeneratorConfig) : {
					Id: null,
					Parameters: []
				}
			}
			this.popupVisible = false;
			setImmediate(() => this.popupVisible = true);
		},
		async save() {
			if (__DEBUG__)
				console.debug('Save');
			this.$set(this.output, 'AiGeneratorConfig', this.aiGenerator?.Id ? _.cloneDeep(this.aiGenerator) : null);
			this.popupVisible = false;
		},
		clear() {
			this.aiGenerator.Id = null;
			this.aiGenerator.Parameters = [];
		},
		loadParameters() {
			this.parameters = [];
			this.isLoading++;
			this.$Data.getExternalApi('AIScriptParameter/List', `aiScriptGeneratorId=${this.aiGenerator.Id}`, 999).then(r => {
				this.parameters = r?.Results || [];
				this.parameters.map(f => {
					if (!this.aiGenerator.Parameters.find(p => p.ParameterId === f.Oid)) {
						this.aiGenerator.Parameters.push({
							ParameterId: f.Oid,
							Output: null,
							Input: null
						});
					}
				});
			}).finally(() => this.isLoading--);
		}
	}
};
</script>
<style lang="scss">
	.web-services--output-ai-generator{
		
	}
</style>
